/**
 * Member Validation Schemas
 * Yup validation schemas for member forms
 */
import * as yup from 'yup';

/**
 * Member registration/update validation schema
 */
export const memberSchema = yup.object({
  firstName: yup
    .string()
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .required('First name is required'),
  lastName: yup
    .string()
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .required('Last name is required'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  phone: yup
    .string()
    .matches(/^(\+255|0)[0-9]{9}$/, 'Please enter a valid Tanzanian phone number')
    .required('Phone number is required'),
  dateOfBirth: yup.date().nullable(),
  gender: yup.string().oneOf(['male', 'female', 'other', '']).nullable(),
  address: yup.string().max(200, 'Address is too long'),
  city: yup.string().max(50, 'City name is too long'),
  region: yup.string().max(50, 'Region name is too long'),
  idType: yup
    .string()
    .oneOf(['national_id', 'passport', 'driving_license', 'voter_id', ''])
    .nullable(),
  idNumber: yup.string().when('idType', {
    is: (val) => val && val !== '',
    then: () => yup.string().required('ID number is required when ID type is selected'),
    otherwise: () => yup.string(),
  }),
});

/**
 * Member update validation schema (partial fields)
 */
export const memberUpdateSchema = yup.object({
  firstName: yup
    .string()
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters'),
  lastName: yup
    .string()
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters'),
  email: yup.string().email('Please enter a valid email address'),
  phone: yup
    .string()
    .matches(/^(\+255|0)[0-9]{9}$/, 'Please enter a valid Tanzanian phone number'),
  dateOfBirth: yup.date().nullable(),
  gender: yup.string().oneOf(['male', 'female', 'other', '']).nullable(),
  address: yup.string().max(200, 'Address is too long'),
  city: yup.string().max(50, 'City name is too long'),
  region: yup.string().max(50, 'Region name is too long'),
});

export default { memberSchema, memberUpdateSchema };
